// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
body {
  font-family: "Urbanist", sans-serif !important;
}

/* 
scss
 */
/* 
Body Theme Color
 */
/* 
Dark Theme Colors
*/
/* 
Button Theme
*/
/* 
Max Dashboard scss
*/
/* 
Min Dashboard scss
*/
/* 
Max Dashboard scss
*/
.ResetPasswordModal_dashboard__mlX8\\+ {
  width: calc(100% - 320px);
  position: relative;
  left: 310px;
  padding: 30px;
  border-radius: 8px;
  min-height: auto !important;
  background-color: #F5F6FA;
  height: calc(100vh - 160px);
  overflow-y: auto;
}

.ResetPasswordModal_dashboardContain__fk-Et {
  width: calc(100% - 320px);
  background-Color: #F5F6FA;
  border-radius: 8px;
}

.ResetPasswordModal_bodythemedark__vdEMg .ResetPasswordModal_dashboardContain__fk-Et,
.ResetPasswordModal_bodythemedark__vdEMg .ResetPasswordModal_dashboard__mlX8\\+,
.ResetPasswordModal_bodythemedark__vdEMg .ResetPasswordModal_cont2__JEBxl {
  background-Color: #0f1824;
}

.ResetPasswordModal_top_header__KeJgC .ResetPasswordModal_top_header_inner__wWM2L {
  background-color: transparent;
  height: auto;
  overflow-y: unset;
}

/* 
Min Dashboard scss
*/
.ResetPasswordModal_cont2__JEBxl {
  width: calc(100% - 50px);
  left: 50px;
  position: relative;
  padding: 30px;
  border-radius: 8px;
  background: #F5F6FA;
  height: calc(100vh - 160px);
  min-height: auto !important;
  overflow-y: auto;
  /* 
  background-Color: \$dashboardbackgroundColor;
    padding-bottom: 8%;
  */
}

.ResetPasswordModal_footer__iZk3Q {
  height: 70px;
}

body {
  background-color: #fff;
}

/* 
THEME CHANGE
*/
.ResetPasswordModal_bodythemelight__zm2-h {
  background-color: #fff;
  padding-top: 90px;
}

.ResetPasswordModal_bodythemedark__vdEMg {
  background-color: #132337;
  padding-top: 90px;
}

/* 
Header Navbar Theme
*/
.ResetPasswordModal_headerthemelight__RUT-V {
  background-color: #fff;
}

.ResetPasswordModal_headerthemedark__G6fuS {
  background-color: #132337;
}

.ResetPasswordModal_top_header__KeJgC {
  min-height: 90px;
  display: flex;
  align-items: center;
  position: fixed;
  width: 100%;
  z-index: 1;
  top: 0;
}

/* 
LEFT MENU THEME CHANGE
*/
.ResetPasswordModal_menuthemelight__KsURa {
  background-color: #fff;
}

.ResetPasswordModal_menuthemedark__OpGtX {
  background-color: #132337;
}

/* 
LEFT MENU LINKS THEME CHANGE
*/
.ResetPasswordModal_menulinklight__U0EpR span {
  color: #666666 !important;
}

.ResetPasswordModal_menulinklight__U0EpR a {
  color: #CBCBCB !important;
}

.ResetPasswordModal_menulinklight__U0EpR:hover span, .ResetPasswordModal_menulinklight__U0EpR:hover a {
  color: #fff !important;
}

.ResetPasswordModal_menulinkdarkSelected__XuEiS {
  background-color: #1c2e45;
  color: #3b82f6;
}

.ResetPasswordModal_menuthemelight__KsURa .ResetPasswordModal_menulinklightSelected__sNOsp {
  /*background-color: \$lightthemecolor;*/
  color: #fff !important;
  background-color: #131F43;
}

.ResetPasswordModal_menulinkdark__alK5Z {
  color: #92afd3 !important;
}

.ResetPasswordModal_menulinklight__U0EpR:hover {
  color: #fff !important;
  background-color: #131F43;
}

.ResetPasswordModal_menulinklight__U0EpR .ResetPasswordModal_sub_arrow__gEcvY svg path {
  stroke: #CBCBCB !important;
}

.ResetPasswordModal_menulinklight__U0EpR:hover .ResetPasswordModal_sub_arrow__gEcvY svg path {
  stroke: #fff !important;
}

.ResetPasswordModal_menulinkdark__alK5Z .ResetPasswordModal_sub_arrow__gEcvY svg path {
  stroke: #92afd3 !important;
}

.ResetPasswordModal_menulinkdark__alK5Z:hover .ResetPasswordModal_sub_arrow__gEcvY svg path {
  stroke: #fff !important;
}

.ResetPasswordModal_menulinkdark__alK5Z:hover {
  background-color: #1c2e45;
  color: #fff;
}

/* 
BODY HEADERS
*/
.ResetPasswordModal_headinglight__WDuH5 {
  color: #60677e;
}

.ResetPasswordModal_headingdark__HwQ6q {
  color: #60677e;
}

/* 
SEARCH BOX THEME COLOR
*/
.ResetPasswordModal_searchboxlight__zcpWw {
  background-color: #fff;
  border: none;
}

.ResetPasswordModal_searchboxdark__Oa6H0 {
  background-color: #132337;
  color: #fff;
  border: none;
}

.ResetPasswordModal_searchboxdark__Oa6H0::placeholder {
  color: #60677e;
}

/* 
CUSTOM TABLE THEME COLOR
*/
.ResetPasswordModal_tableheadlight__eCjhU {
  background-color: #131F43;
  border-radius: 5px 5px 0px 0px;
}

.ResetPasswordModal_tableheadlight__eCjhU th {
  color: #fff;
}

thead .ResetPasswordModal_tableheadlight__eCjhU th:first-child,
thead .ResetPasswordModal_tableheaddark__e6a4E th:first-child {
  border-radius: 5px 0 0 0px;
}

thead .ResetPasswordModal_tableheadlight__eCjhU th:last-child,
thead .ResetPasswordModal_tableheaddark__e6a4E th:last-child {
  border-radius: 0 5px 0px 0;
}

th:first-child {
  border-radius: 0px;
}

td:last-child {
  border-radius: 0px;
}

table.ResetPasswordModal_table__g8\\+-G.ResetPasswordModal_table-borderless__Mce5w {
  border-collapse: separate !important;
  border-spacing: 0 0px !important;
}

.ResetPasswordModal_tableheaddark__e6a4E {
  background-color: #132337;
  color: #fff;
}

.ResetPasswordModal_table-borderless__Mce5w tr:nth-child(even) {
  background-color: #F9FAFB;
}

.ResetPasswordModal_table-borderless__Mce5w .ResetPasswordModal_left-section__ZfA8D {
  padding-top: 10px;
}

.ResetPasswordModal_tablebodylight__i5KAv td,
.ResetPasswordModal_tablebodydark__dyZaU td {
  padding: 0.5rem 1rem !important;
  line-height: 45px;
}

.ResetPasswordModal_tablebodylight__i5KAv {
  background-color: #fff;
}
.ResetPasswordModal_tablebodylight__i5KAv:hover {
  background-color: #ddecf9;
  cursor: auto;
}

.ResetPasswordModal_tablebodydark__dyZaU {
  /* background-color: \$primarydark-color; */
  color: #60677e;
}
.ResetPasswordModal_tablebodydark__dyZaU:hover {
  background-color: rgba(33, 150, 243, 0.1);
  cursor: auto;
}

/* 
PAGINATION THEME COLOR
*/
.ResetPasswordModal_paginationlight__Ce\\+s6 {
  color: #60677e !important;
  font-size: 13px !important;
}

.ResetPasswordModal_paginationdark__PV9Cv {
  color: #60677e !important;
  font-size: 13px !important;
}

/* 
SETTING FORM THEME COLOR
*/
.ResetPasswordModal_formthemelight__jVE1H {
  background-color: #fff;
  color: #1d1d1d !important;
  box-shadow: 0px 10px 35px 0px rgba(56, 71, 109, 0.08);
}

.ResetPasswordModal_formthemedark__77r9J {
  background-color: #132337;
  color: #60677e !important;
  font-size: 14px;
}
.ResetPasswordModal_formthemedark__77r9J ::placeholder {
  color: #60677e;
}

/* 
VIEW FORM DETAILS BOX THEME COLOR
*/
.ResetPasswordModal_viewformlight__kkgA5 {
  background-color: #f3f6f9;
}

.ResetPasswordModal_permissionboxlight__WeqyB {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
}

.ResetPasswordModal_permissionboxdark__3tPUy {
  background-color: #0f1824;
  border: solid 1px #242434;
}

.ResetPasswordModal_errormsgclr__CPNMU {
  color: red;
  font-size: 14px;
  margin-top: 5px;
}

/* 
Graph theme
*/
.ResetPasswordModal_graphclrlight__a\\+biF {
  background-color: #fff;
}

.ResetPasswordModal_graphclrdark__zhiQF {
  background-color: #132337;
}

/* 
Counter theme
*/
#ResetPasswordModal_card1bglight__xX1Nb {
  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */
  background-color: #fff;
}

#ResetPasswordModal_card1bgdark__on2aN {
  background: #392f28;
}

#ResetPasswordModal_card2bglight__UhOhK {
  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */
  background-color: #fff;
}

#ResetPasswordModal_card2bgdark__CTvTF {
  background: #1c3238;
}

#ResetPasswordModal_card3bglight__L5QQz {
  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */
  background-color: #fff;
}

#ResetPasswordModal_card3bgdark__8Fusg {
  background: #3a2434;
}

#ResetPasswordModal_card4bglight__fj1DU {
  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */
  background-color: #fff;
}

#ResetPasswordModal_card4bgdark__rH\\+64 {
  background: #2f264f;
}

#ResetPasswordModal_card1bgdark__on2aN a, #ResetPasswordModal_card1bgdark__on2aN p,
#ResetPasswordModal_card2bgdark__CTvTF a, #ResetPasswordModal_card2bgdark__CTvTF p,
#ResetPasswordModal_card3bgdark__8Fusg a, #ResetPasswordModal_card3bgdark__8Fusg p,
#ResetPasswordModal_card4bgdark__rH\\+64 a, #ResetPasswordModal_card4bgdark__rH\\+64 p {
  color: #fff;
}

/* 
Action button theme
*/
.ResetPasswordModal_actionbtnlight__AZF1o {
  color: rgba(70, 71, 91, 0.8705882353);
}

.ResetPasswordModal_actionbtnlight__AZF1o:hover {
  cursor: pointer;
}

.ResetPasswordModal_actionbtndark__4FOL8 {
  color: #60677e;
}

/* 
profile dropdowntheme
*/
.ResetPasswordModal_profiledropdownlight__2hE-5 {
  background-color: #fff;
}

.ResetPasswordModal_profiledropdowndark__3YFIN {
  background-color: #151521;
}

.ResetPasswordModal_settingsection__FGU\\+k #ResetPasswordModal_addform__bZzkV.ResetPasswordModal_formthemedark__77r9J .ResetPasswordModal_savebtn__eP9aA {
  background-color: #3b82f6;
  color: #fff;
}

#ResetPasswordModal_addform__bZzkV.ResetPasswordModal_formthemedark__77r9J .ResetPasswordModal_savebtn__eP9aA {
  background-color: #3b82f6;
  color: #fff;
}

.ResetPasswordModal_profile_conatiner__VNaHQ {
  border-radius: 5px !important;
}

.ResetPasswordModal_bodythemedark__vdEMg .ResetPasswordModal_ag-theme-alpine__jJfn4 .ResetPasswordModal_ag-row__a-JvN {
  background: #000 !important;
}

.ResetPasswordModal_bodythemedark__vdEMg .ResetPasswordModal_formbtn__RR\\+nP {
  background-color: #3b82f6;
}

.ResetPasswordModal_bodythemedark__vdEMg .ResetPasswordModal_formbtn__RR\\+nP:hover {
  background-color: #2563eb;
}

.ResetPasswordModal_bodythemedark__vdEMg .ResetPasswordModal_resetbtn__ADW5\\+ {
  color: #fff;
  background-color: transparent;
  border: solid 1px #3b82f6;
}

.ResetPasswordModal_bodythemedark__vdEMg .ResetPasswordModal_resetbtn__ADW5\\+:hover {
  background-color: #3b82f6;
}

.ResetPasswordModal_headingdark__HwQ6q span {
  background-color: #132337;
}

.ResetPasswordModal_resetbtn__ADW5\\+ {
  font-size: 16px;
  font-weight: 600;
  border-radius: 5px;
  background-color: transparent;
  border: solid 1px #131F43;
  color: #131F43;
  min-width: 113px;
}

.ResetPasswordModal_resetbtn__ADW5\\+:hover,
.ResetPasswordModal_resetbtn__ADW5\\+:active,
.ResetPasswordModal_resetbtn__ADW5\\+:focus {
  background-color: #131F43;
  color: #fff;
}

.ResetPasswordModal_addBtn__6GD2V {
  min-width: 140px;
  height: 44px;
  color: #fff;
  background-color: #38A169;
  border: none;
  font-size: 16px;
  font-weight: 600;
}

.ResetPasswordModal_addbtnlight__6Po0c {
  background-color: #38A169;
}

.ResetPasswordModal_addbtndark__OMnlb {
  background-color: #3b82f6;
}

.ResetPasswordModal_addbtndark__OMnlb:hover {
  background-color: #2563eb;
}

.ResetPasswordModal_formthemedark__77r9J label {
  color: #92afd3;
}

.ResetPasswordModal_addBtn__6GD2V svg {
  margin-right: 10px;
  position: relative;
  top: 2px;
}

.ResetPasswordModal_addBtn__6GD2V:hover {
  color: #fff;
  background-color: #38A169;
  border: none;
}

.ResetPasswordModal_cust_addBtn__ontZk.ResetPasswordModal_addBtn__6GD2V svg {
  top: 2px;
}

.ResetPasswordModal_deleteBtn__cWGEW {
  min-width: 130px;
  height: 50px;
  background-color: #F94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.ResetPasswordModal_deleteBtn__cWGEW {
  min-width: 130px;
  height: 50px;
  background-color: #F94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.ResetPasswordModal_deleteBtn__cWGEW:active, .ResetPasswordModal_deleteBtn__cWGEW:focus {
  background-color: #F94747 !important;
  color: #fff !important;
  box-shadow: none !important;
}

.ResetPasswordModal_deleteBtn__cWGEW svg {
  margin-right: 10px;
  position: relative;
  top: -2px;
}

.ResetPasswordModal_deleteBtn__cWGEW:hover,
.ResetPasswordModal_deleteBtn__cWGEW:active,
.ResetPasswordModal_deleteBtn__cWGEW:focus {
  background-color: #F94747;
  color: #fff;
  border: none;
}

.ResetPasswordModal_confirmBtn__qYUxn {
  background-color: #131F43;
}

.ResetPasswordModal_confirmBtn__qYUxn:hover,
.ResetPasswordModal_confirmBtn__qYUxn:active,
.ResetPasswordModal_confirmBtn__qYUxn:focus {
  background-color: #131F43;
}

.ResetPasswordModal_confirmBtn__qYUxn svg {
  top: 0;
}

.ResetPasswordModal_delPopContainer__Amlsf .ResetPasswordModal_modal-body__a1NE3 {
  padding: 25px;
  text-align: center;
}

.ResetPasswordModal_delPopContainer__Amlsf .ResetPasswordModal_delet_icon__PK8c6 {
  margin-bottom: 11px;
}

.ResetPasswordModal_delPopContainer__Amlsf p {
  color: #131f43;
  font-size: 14px;
  font-weight: 700;
}

.ResetPasswordModal_arrowback__gXsfb svg {
  fill: #000;
}

.ResetPasswordModal_bodythemedark__vdEMg .ResetPasswordModal_arrowback__gXsfb {
  background-color: rgba(59, 130, 246, 0.2);
  color: #3b82f6;
}

.ResetPasswordModal_bodythemedark__vdEMg .ResetPasswordModal_arrowback__gXsfb svg {
  fill: #3b82f6;
}

.ResetPasswordModal_bodythemedark__vdEMg .ResetPasswordModal_drpdwn_btn__bWAdZ {
  background-color: #132337;
}

.ResetPasswordModal_bodythemedark__vdEMg .ResetPasswordModal_empname__umGWH {
  color: #92afd3 !important;
}

.ResetPasswordModal_bodythemedark__vdEMg .ResetPasswordModal_navitemli__tGeEV a {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.ResetPasswordModal_bodythemedark__vdEMg .ResetPasswordModal_tabnavli__Kckcy a.ResetPasswordModal_settingsgeneral__HEmo\\+,
.ResetPasswordModal_bodythemedark__vdEMg .ResetPasswordModal_tabnavli__Kckcy a.ResetPasswordModal_settingslinks__Lg1nQ:hover {
  background-color: #3b82f6;
  color: #fff;
}

.ResetPasswordModal_bodythemedark__vdEMg .ResetPasswordModal_tabnavli__Kckcy a.ResetPasswordModal_settingslinks__Lg1nQ {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.ResetPasswordModal_headerthemedark__G6fuS .ResetPasswordModal_dropdown_menu_contain__vpVJb {
  background-color: #1c2e45;
  color: #fff;
}

.ResetPasswordModal_headerthemedark__G6fuS .ResetPasswordModal_dropdown_menu_contain__vpVJb ul li a,
.ResetPasswordModal_headerthemedark__G6fuS .ResetPasswordModal_dropdown_menu_contain__vpVJb .ResetPasswordModal_dropdown_item__-3JF2,
.ResetPasswordModal_headerthemedark__G6fuS .ResetPasswordModal_dropdown_menu_contain__vpVJb .ResetPasswordModal_dropdown_item__-3JF2 h5 {
  color: #fff;
}

.ResetPasswordModal_headerthemedark__G6fuS .ResetPasswordModal_dropdown_menu_contain__vpVJb ul li a:hover,
.ResetPasswordModal_headerthemedark__G6fuS .ResetPasswordModal_dropdown_menu_contain__vpVJb .ResetPasswordModal_dropdown_item__-3JF2:hover {
  background-color: #132337;
  color: #fff;
}

.ResetPasswordModal_dropdown_item__-3JF2:active {
  background-color: #F5F6FA;
}

.ResetPasswordModal_profile_arrrow_dwn__ZHLBb {
  stroke: #132337;
}

.ResetPasswordModal_headerthemedark__G6fuS .ResetPasswordModal_profile_arrrow_dwn__ZHLBb {
  stroke: #fff;
}

.ResetPasswordModal_dateinputbox1__FkvKw input,
.ResetPasswordModal_dateinputbox1__FkvKw span {
  color: #fff !important;
}

/* LOGOUT MODAL */
@media only screen and (max-width: 1200px) {
  .ResetPasswordModal_tableheadlight__eCjhU th {
    min-width: 100px;
  }
}
@media only screen and (max-width: 1024px) {
  .ResetPasswordModal_dashboard__mlX8\\+ {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    padding: 10px 10px !important;
  }
  .ResetPasswordModal_cont2__JEBxl {
    height: calc(100vh - 160px);
    overflow-y: auto;
  }
}
@media only screen and (max-width: 998px) {
  /* #dashboardcont2{
     height: auto !important;
   }*/
}
@media only screen and (max-width: 767px) {
  .ResetPasswordModal_sectionright__3Nem\\+ {
    float: unset !important;
  }
  .ResetPasswordModal_dashboard__mlX8\\+ {
    padding: 10px 10px !important;
  }
}
@media only screen and (max-width: 600px) {
  .ResetPasswordModal_cont2__JEBxl {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    position: relative !important;
    padding: 10px !important;
  }
  .ResetPasswordModal_bodythemelight__zm2-h, .ResetPasswordModal_bodythemedark__vdEMg {
    padding-top: 110px;
  }
}
@media (min-width: 576px) {
  .ResetPasswordModal_exer_modal_contain__U4qAc .ResetPasswordModal_modal-dialog__BEH\\+G {
    max-width: 1055px;
  }
  .ResetPasswordModal_delPopContainer__Amlsf .ResetPasswordModal_modal-dialog__BEH\\+G {
    max-width: 350px;
  }
}
.ResetPasswordModal_resetModal__XZYrU .ResetPasswordModal_modal-dialog__BEH\\+G {
  max-width: 500px;
}

.ResetPasswordModal_modalHeader__EBC9y {
  background: linear-gradient(135deg, #39979d 0%, #2d7277 100%);
  color: white;
  border-bottom: none;
  padding: 20px 25px;
}
.ResetPasswordModal_modalHeader__EBC9y .ResetPasswordModal_modal-title__CwTS5 {
  font-size: 18px;
  font-weight: 600;
  margin: 0;
  display: flex;
  align-items: center;
}
.ResetPasswordModal_modalHeader__EBC9y .ResetPasswordModal_modal-title__CwTS5 i {
  font-size: 20px;
}
.ResetPasswordModal_modalHeader__EBC9y .ResetPasswordModal_btn-close__SmJcb {
  filter: invert(1);
  opacity: 0.8;
}
.ResetPasswordModal_modalHeader__EBC9y .ResetPasswordModal_btn-close__SmJcb:hover {
  opacity: 1;
}

.ResetPasswordModal_modalBody__lCzsk {
  padding: 25px;
  background-color: #f8f9fa;
}
.ResetPasswordModal_modalBody__lCzsk .ResetPasswordModal_description__8QcFL {
  font-size: 14px;
  color: #6c757d;
  margin-bottom: 25px;
  line-height: 1.5;
  text-align: center;
}

.ResetPasswordModal_passwordField__Nns63 {
  margin-bottom: 20px;
  text-align: left;
}

.ResetPasswordModal_passwordLabel__0VcsR {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 8px;
  text-align: left;
}
.ResetPasswordModal_passwordLabel__0VcsR span {
  color: #dc3545;
  margin-left: 2px;
}

.ResetPasswordModal_inputContainer__JV9ee {
  position: relative;
  display: flex;
  align-items: center;
}

.ResetPasswordModal_passwordInput__g1ufS {
  width: 100%;
  padding: 12px 45px 12px 14px;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  font-size: 14px;
  outline: none;
  transition: all 0.3s ease;
  background-color: #ffffff;
}
.ResetPasswordModal_passwordInput__g1ufS:focus {
  border-color: #39979d;
  box-shadow: 0 0 0 3px rgba(57, 151, 157, 0.1);
}
.ResetPasswordModal_passwordInput__g1ufS::placeholder {
  color: #adb5bd;
}
.ResetPasswordModal_passwordInput__g1ufS:disabled {
  background-color: #f8f9fa;
  cursor: not-allowed;
  opacity: 0.7;
}

.ResetPasswordModal_eyeButton__2SpcC {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  padding: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all 0.2s ease;
  z-index: 1;
}
.ResetPasswordModal_eyeButton__2SpcC:hover {
  background-color: #f0f0f0;
}
.ResetPasswordModal_eyeButton__2SpcC:focus {
  outline: 2px solid #39979d;
  outline-offset: 2px;
}
.ResetPasswordModal_eyeButton__2SpcC:active {
  background-color: #e0e0e0;
}
.ResetPasswordModal_eyeButton__2SpcC img {
  width: 18px;
  height: 18px;
  opacity: 0.6;
  transition: opacity 0.2s ease;
}
.ResetPasswordModal_eyeButton__2SpcC:hover img {
  opacity: 1;
}

.ResetPasswordModal_errorMessage__QnCsw,
.ResetPasswordModal_text-red__vm3VJ {
  color: #dc3545;
  font-size: 12px;
  margin-top: 6px;
  margin-bottom: 0;
  text-align: left;
  display: flex;
  align-items: center;
  gap: 4px;
}
.ResetPasswordModal_errorMessage__QnCsw::before,
.ResetPasswordModal_text-red__vm3VJ::before {
  content: "⚠";
  font-size: 14px;
}

.ResetPasswordModal_modalFooter__wdsLu {
  background-color: #ffffff;
  border-top: 1px solid #e9ecef;
  padding: 20px 25px;
  gap: 10px;
  display: flex;
  justify-content: flex-end;
}

.ResetPasswordModal_cancelButton__dhzTl {
  padding: 10px 20px;
  font-weight: 500;
  border-radius: 6px;
  transition: all 0.2s ease;
  min-width: 100px;
}
.ResetPasswordModal_cancelButton__dhzTl:hover:not(:disabled) {
  background-color: #6c757d;
  border-color: #6c757d;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.ResetPasswordModal_resetPasswordBtn__ihrqO {
  padding: 10px 20px;
  font-weight: 600;
  border-radius: 6px;
  background-color: #39979d;
  border-color: #39979d;
  color: white;
  min-width: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all 0.2s ease;
}
.ResetPasswordModal_resetPasswordBtn__ihrqO:hover:not(:disabled) {
  background-color: #2d7277;
  border-color: #2d7277;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(57, 151, 157, 0.3);
}
.ResetPasswordModal_resetPasswordBtn__ihrqO:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}
.ResetPasswordModal_resetPasswordBtn__ihrqO i {
  font-size: 14px;
}

.ResetPasswordModal_bodythemedark__vdEMg .ResetPasswordModal_modalBody__lCzsk {
  background-color: #2d2d2d;
  color: #e0e0e0;
}
.ResetPasswordModal_bodythemedark__vdEMg .ResetPasswordModal_modalBody__lCzsk .ResetPasswordModal_description__8QcFL {
  color: #b0b0b0;
}
.ResetPasswordModal_bodythemedark__vdEMg .ResetPasswordModal_passwordLabel__0VcsR {
  color: #e0e0e0;
}
.ResetPasswordModal_bodythemedark__vdEMg .ResetPasswordModal_passwordInput__g1ufS {
  background-color: #3d3d3d;
  border-color: #555;
  color: #e0e0e0;
}
.ResetPasswordModal_bodythemedark__vdEMg .ResetPasswordModal_passwordInput__g1ufS:focus {
  border-color: #39979d;
  box-shadow: 0 0 0 3px rgba(57, 151, 157, 0.2);
}
.ResetPasswordModal_bodythemedark__vdEMg .ResetPasswordModal_passwordInput__g1ufS::placeholder {
  color: #888;
}
.ResetPasswordModal_bodythemedark__vdEMg .ResetPasswordModal_eyeButton__2SpcC:hover {
  background-color: #4d4d4d;
}
.ResetPasswordModal_bodythemedark__vdEMg .ResetPasswordModal_eyeButton__2SpcC:active {
  background-color: #5d5d5d;
}
.ResetPasswordModal_bodythemedark__vdEMg .ResetPasswordModal_modalFooter__wdsLu {
  background-color: #2d2d2d;
  border-color: #555;
}
.ResetPasswordModal_bodythemedark__vdEMg .ResetPasswordModal_cancelButton__dhzTl {
  background-color: #6c757d;
  border-color: #6c757d;
  color: white;
}
.ResetPasswordModal_bodythemedark__vdEMg .ResetPasswordModal_cancelButton__dhzTl:hover:not(:disabled) {
  background-color: #5a6268;
  border-color: #5a6268;
}

@media (max-width: 576px) {
  .ResetPasswordModal_resetModal__XZYrU .ResetPasswordModal_modal-dialog__BEH\\+G {
    margin: 10px;
    max-width: calc(100% - 20px);
  }
  .ResetPasswordModal_modalHeader__EBC9y {
    padding: 15px 20px;
  }
  .ResetPasswordModal_modalHeader__EBC9y .ResetPasswordModal_modal-title__CwTS5 {
    font-size: 16px;
  }
  .ResetPasswordModal_modalBody__lCzsk {
    padding: 20px;
  }
  .ResetPasswordModal_modalFooter__wdsLu {
    padding: 15px 20px;
    flex-direction: column;
  }
  .ResetPasswordModal_modalFooter__wdsLu .ResetPasswordModal_cancelButton__dhzTl,
.ResetPasswordModal_modalFooter__wdsLu .ResetPasswordModal_resetPasswordBtn__ihrqO {
    width: 100%;
    margin: 2px 0;
  }
  .ResetPasswordModal_passwordField__Nns63 {
    margin-bottom: 18px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/NewModals/ResetPasswordModal/ResetPasswordModal.module.scss","webpack://./src/styles/Variables/Variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACEhB;EACE,8CAAA;ADCF;;ACEA;;EAAA;AAkDA;;EAAA;AAWA;;CAAA;AAKA;;CAAA;AASA;;CAAA;AAQA;;CAAA;AAMA;;CAAA;AAIA;EACE,yBAhBe;EAiBf,kBAAA;EACA,WAhBc;EAiBd,aAhBiB;EAiBjB,kBAAA;EACA,2BAAA;EACA,yBA1FO;EA2FP,2BAAA;EACA,gBAAA;ADvEF;;ACyEA;EACE,yBAAA;EACA,yBAhGO;EAiGP,kBAAA;ADtEF;;ACwEA;;;EAGE,yBAlEoB;ADHtB;;ACuEA;EACE,6BAAA;EACA,YAAA;EACA,iBAAA;ADpEF;;ACuEA;;CAAA;AAIA;EACE,wBAvCU;EAwCV,UAvCS;EAwCT,kBAAA;EACA,aA/CiB;EAgDjB,kBAAA;EACA,mBAxHO;EAyHP,2BAAA;EACA,2BAAA;EACA,gBAAA;EACA;;;GAAA;ADlEF;;AC2EA;EACE,YAAA;ADxEF;;AC2EA;EACE,sBA5FY;ADoBd;;AC2EA;;CAAA;AAGA;EACE,sBAnGY;EAoGZ,iBAAA;ADxEF;;AC0EA;EACE,yBAlHgB;EAmHhB,iBAAA;ADvEF;;AC0EA;;CAAA;AAGA;EACE,sBA/GY;ADwCd;;AC0EA;EACE,yBA9HgB;ADuDlB;;ACyEA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;EACA,MAAA;ADtEF;;ACyEA;;CAAA;AAGA;EACE,sBAnIY;AD6Dd;;ACwEA;EACE,yBAjJgB;AD4ElB;;ACwEA;;CAAA;AAGA;EACE,yBAAA;ADrEF;;ACwEA;EACE,yBAAA;ADrEF;;ACwEA;EACE,sBAAA;ADrEF;;ACwEA;EACE,yBAlKsB;EAmKtB,cA7KkB;ADwGpB;;ACuEA;EACE,sCAAA;EACA,sBAAA;EACA,yBA5Mc;ADwIhB;;ACuEA;EACE,yBAAA;ADpEF;;ACuEA;EACE,sBAAA;EACA,yBArNc;ADiJhB;;ACuEA;EACE,0BAAA;ADpEF;;ACuEA;EACE,uBAAA;ADpEF;;ACuEA;EACE,0BAAA;ADpEF;;ACuEA;EACE,uBAAA;ADpEF;;ACuEA;EACE,yBArMsB;EAsMtB,WA7LY;ADyHd;;ACuEA;;CAAA;AAGA;EACE,cAjMe;AD6HjB;;ACuEA;EACE,cArMe;ADiIjB;;ACuEA;;CAAA;AAGA;EACE,sBA/MY;EAgNZ,YAAA;ADpEF;;ACuEA;EACE,yBA/NgB;EAgOhB,WArNY;EAsNZ,YAAA;ADpEF;;ACsEA;EACE,cAtNe;ADmJjB;;ACsEA;;CAAA;AAGA;EACE,yBA7Qc;EA8Qd,8BAAA;ADnEF;;ACqEA;EACE,WApOY;ADkKd;;ACoEA;;EAEE,0BAAA;ADjEF;;ACmEA;;EAEE,0BAAA;ADhEF;;ACkEA;EACE,kBAAA;AD/DF;;ACiEA;EACE,kBAAA;AD9DF;;ACgEA;EACE,oCAAA;EACA,gCAAA;AD7DF;;ACgEA;EACE,yBAlPkB;EAmPlB,WA3PY;AD8Ld;;AC+DA;EACE,yBAAA;AD5DF;;AC8DA;EACE,iBAAA;AD3DF;;AC6DA;;EAEE,+BAAA;EACA,iBAAA;AD1DF;;AC4DA;EACE,sBAzQY;ADgNd;AC2DE;EACE,yBAAA;EACA,YAAA;ADzDJ;;AC4DA;EACC,0CAAA;EACC,cA/Qe;ADsNjB;AC2DE;EACE,yCAAA;EACA,YAAA;ADzDJ;;AC6DA;;CAAA;AAGA;EACE,yBAAA;EACA,0BAAA;AD1DF;;AC4DA;EACE,yBAAA;EACA,0BAAA;ADzDF;;AC4DA;;CAAA;AAGA;EACE,sBA1SY;EA2SZ,yBAAA;EACA,qDAAA;ADzDF;;AC2DA;EACE,yBAvSkB;EAwSlB,yBAAA;EACA,eAAA;ADxDF;AC0DE;EACE,cAjTa;ADyPjB;;AC6DA;;CAAA;AAGA;EACE,yBAhUgB;ADsQlB;;AC6DA;EACE,yBAAA;EACA,yBAAA;AD1DF;;AC4DA;EACE,yBA/UoB;EAgVpB,yBAAA;ADzDF;;AC4DA;EACE,UAAA;EACA,eAAA;EACA,eAAA;ADzDF;;AC4DA;;CAAA;AAGA;EACE,sBAnVY;AD0Rd;;AC4DA;EACE,yBA/UkB;ADsRpB;;AC6DA;;CAAA;AAGA;EACE,iGAAA;EACA,sBAhWY;ADsSd;;AC6DA;EACE,mBAAA;AD1DF;;AC6DA;EACE,gGAAA;EACA,sBAzWY;AD+Sd;;AC6DA;EACE,mBAAA;AD1DF;;AC6DA;EACE,gGAAA;EACA,sBAlXY;ADwTd;;AC6DA;EACE,mBAAA;AD1DF;;AC6DA;EACE,gGAAA;EACA,sBA3XY;ADiUd;;AC6DA;EACE,mBAAA;AD1DF;;AC6DA;;;;EAIE,WAtYY;AD4Ud;;AC6DA;;CAAA;AAGA;EACE,qCAAA;AD1DF;;AC4DA;EACE,eAAA;ADzDF;;AC2DA;EACE,cAhZe;ADwVjB;;AC4DA;;CAAA;AAGA;EACE,sBAAA;ADzDF;;AC4DA;EACE,yBAAA;ADzDF;;AC4DA;EACE,yBApbkB;EAqblB,WApaY;AD2Wd;;AC2DA;EACE,yBAxbkB;EAyblB,WAxaY;ADgXd;;AC2DA;EACE,6BAAA;ADxDF;;AC2DA;EACE,2BAAA;ADxDF;;AC2DA;EACE,yBArckB;AD6YpB;;AC2DA;EACE,yBAxcwB;ADgZ1B;;AC2DA;EACE,WA5bY;EA6bZ,6BAAA;EACA,yBAAA;ADxDF;;AC2DA;EACE,yBAndkB;AD2ZpB;;AC4DA;EACE,yBAldgB;ADyZlB;;AC4DA;EACE,eAAA;EACA,gBA/fc;EAggBd,kBAAA;EACA,6BAAA;EACA,yBAAA;EACA,cA7fc;EA8fd,gBAAA;ADzDF;;AC2DA;;;EAGE,yBAngBc;EAogBd,WAvdY;AD+Zd;;AC2DA;EACE,gBAAA;EACA,YAAA;EACA,WA7dY;EA8dZ,yBAzfY;EA0fZ,YAAA;EACA,eAAA;EACA,gBAphBc;AD4dhB;;AC2DA;EACE,yBAhgBY;ADwcd;;AC0DA;EACE,yBAzfkB;ADkcpB;;ACyDA;EACE,yBA3fwB;ADqc1B;;ACyDA;EACE,cAjgBiB;AD2cnB;;AC0DA;EACE,kBAAA;EACA,kBAAA;EACA,QAAA;ADvDF;;AC0DA;EACE,WA1fY;EA2fZ,yBAthBY;EAuhBZ,YAAA;ADvDF;;AC0DA;EACE,QAAA;ADvDF;;AC0DA;EACE,gBAAA;EACA,YAAA;EACA,yBA1hBW;EA2hBX,WAvgBY;EAwgBZ,eAAA;EACA,gBA5jBc;EA6jBd,YAAA;ADvDF;;AC0DA;EACE,gBAAA;EACA,YAAA;EACA,yBApiBW;EAqiBX,WAjhBY;EAkhBZ,eAAA;EACA,gBAtkBc;EAukBd,YAAA;ADvDF;;AC0DA;EACE,oCAAA;EACA,sBAAA;EACA,2BAAA;ADvDF;;AC0DA;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;ADvDF;;AC0DA;;;EAGE,yBA1jBW;EA2jBX,WAviBY;EAwiBZ,YAAA;ADvDF;;AC0DA;EACE,yBAzlBc;ADkiBhB;;AC0DA;;;EAGE,yBA/lBc;ADwiBhB;;AC0DA;EACE,MAAA;ADvDF;;AC4DA;EACE,aAAA;EACA,kBAAA;ADzDF;;AC4DA;EACE,mBAAA;ADzDF;;AC4DA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;ADzDF;;AC4DA;EACE,UAAA;ADzDF;;AC4DA;EACE,yCA9lBc;EA+lBd,cAnmBkB;AD0iBpB;;AC4DA;EACE,aAvmBkB;AD8iBpB;;AC4DA;EACE,yBAnmBgB;AD0iBlB;;AC4DA;EACE,yBAAA;ADzDF;;AC4DA;EACE,6BAAA;EACA,yBAAA;EACA,WAlmBY;ADyiBd;;AC4DA;;EAEE,yBAxnBkB;EAynBlB,WAxmBY;AD+iBd;;AC2DA;EACE,6BAAA;EACA,yBAAA;EACA,WA7mBY;ADqjBd;;AC2DA;EACE,yBA1nBsB;EA2nBtB,WAlnBY;AD0jBd;;AC2DA;;;EAGE,WAxnBY;ADgkBd;;AC2DA;;EAEE,yBAxoBgB;EAyoBhB,WA9nBY;ADskBd;;AC2DA;EACE,yBAhrBO;ADwnBT;;AC2DA;EACE,eAjpBgB;ADylBlB;;AC2DA;EACE,YA1oBY;ADklBd;;AC2DA;;EAEE,sBAAA;ADxDF;;AC2DA,iBAAA;AAUA;EACE;IACE,gBAAA;EDjEF;AACF;ACmEA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;EDjEF;ECmEA;IACE,2BAAA;IACA,gBAAA;EDjEF;AACF;ACmEA;EACC;;KAAA;AD/DD;ACmEA;EACE;IACE,uBAAA;EDjEF;ECmEA;IACE,6BAAA;EDjEF;AACF;ACmEA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;IACA,wBAAA;EDjEF;ECmEA;IACE,kBAAA;EDjEF;AACF;ACoEA;EACE;IACI,iBAAA;EDlEJ;ECoEA;IACI,gBAAA;EDlEJ;AACF;AAnsBE;EACE,gBAAA;AAqsBJ;;AAjsBA;EACE,6DAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;AAosBF;AAlsBE;EACE,eAAA;EACA,gBAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;AAosBJ;AAlsBI;EACE,eAAA;AAosBN;AAhsBE;EACE,iBAAA;EACA,YAAA;AAksBJ;AAhsBI;EACE,UAAA;AAksBN;;AA7rBA;EACE,aAAA;EACA,yBAAA;AAgsBF;AA9rBE;EACE,eAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AAgsBJ;;AA5rBA;EACE,mBAAA;EACA,gBAAA;AA+rBF;;AA5rBA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AA+rBF;AA7rBE;EACE,cAAA;EACA,gBAAA;AA+rBJ;;AA3rBA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;AA8rBF;;AA3rBA;EACE,WAAA;EACA,4BAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,yBAAA;EACA,yBAAA;AA8rBF;AA5rBE;EACE,qBAAA;EACA,6CAAA;AA8rBJ;AA3rBE;EACE,cAAA;AA6rBJ;AA1rBE;EACE,yBAAA;EACA,mBAAA;EACA,YAAA;AA4rBJ;;AAxrBA;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;EACA,UAAA;AA2rBF;AAzrBE;EACE,yBAAA;AA2rBJ;AAxrBE;EACE,0BAAA;EACA,mBAAA;AA0rBJ;AAvrBE;EACE,yBAAA;AAyrBJ;AAtrBE;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,6BAAA;AAwrBJ;AArrBE;EACE,UAAA;AAurBJ;;AAnrBA;;EAEE,cAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAsrBF;AAprBE;;EACE,YAAA;EACA,eAAA;AAurBJ;;AAnrBA;EACE,yBAAA;EACA,6BAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,yBAAA;AAsrBF;;AAnrBA;EACE,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;AAsrBF;AAprBE;EACE,yBAAA;EACA,qBAAA;EACA,2BAAA;EACA,wCAAA;AAsrBJ;;AAlrBA;EACE,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,yBAAA;AAqrBF;AAnrBE;EACE,yBAAA;EACA,qBAAA;EACA,2BAAA;EACA,6CAAA;AAqrBJ;AAlrBE;EACE,YAAA;EACA,mBAAA;AAorBJ;AAjrBE;EACE,eAAA;AAmrBJ;;AA7qBE;EACE,yBAAA;EACA,cAAA;AAgrBJ;AA9qBI;EACE,cAAA;AAgrBN;AA5qBE;EACE,cAAA;AA8qBJ;AA3qBE;EACE,yBAAA;EACA,kBAAA;EACA,cAAA;AA6qBJ;AA3qBI;EACE,qBAAA;EACA,6CAAA;AA6qBN;AA1qBI;EACE,WAAA;AA4qBN;AAvqBI;EACE,yBAAA;AAyqBN;AAtqBI;EACE,yBAAA;AAwqBN;AApqBE;EACE,yBAAA;EACA,kBAAA;AAsqBJ;AAnqBE;EACE,yBAAA;EACA,qBAAA;EACA,YAAA;AAqqBJ;AAnqBI;EACE,yBAAA;EACA,qBAAA;AAqqBN;;AA/pBA;EAEI;IACE,YAAA;IACA,4BAAA;EAiqBJ;EA7pBA;IACE,kBAAA;EA+pBF;EA7pBE;IACE,eAAA;EA+pBJ;EA3pBA;IACE,aAAA;EA6pBF;EA1pBA;IACE,kBAAA;IACA,sBAAA;EA4pBF;EA1pBE;;IAEE,WAAA;IACA,aAAA;EA4pBJ;EAxpBA;IACE,mBAAA;EA0pBF;AACF","sourcesContent":["@import \"../../../styles/Variables/Variables.scss\";\n\n// Reset Password Modal Styles\n.resetModal {\n  .modal-dialog {\n    max-width: 500px;\n  }\n}\n\n.modalHeader {\n  background: linear-gradient(135deg, #39979d 0%, #2d7277 100%);\n  color: white;\n  border-bottom: none;\n  padding: 20px 25px;\n\n  .modal-title {\n    font-size: 18px;\n    font-weight: 600;\n    margin: 0;\n    display: flex;\n    align-items: center;\n\n    i {\n      font-size: 20px;\n    }\n  }\n\n  .btn-close {\n    filter: invert(1);\n    opacity: 0.8;\n\n    &:hover {\n      opacity: 1;\n    }\n  }\n}\n\n.modalBody {\n  padding: 25px;\n  background-color: #f8f9fa;\n\n  .description {\n    font-size: 14px;\n    color: #6c757d;\n    margin-bottom: 25px;\n    line-height: 1.5;\n    text-align: center;\n  }\n}\n\n.passwordField {\n  margin-bottom: 20px;\n  text-align: left;\n}\n\n.passwordLabel {\n  display: block;\n  font-size: 14px;\n  font-weight: 600;\n  color: #2c3e50;\n  margin-bottom: 8px;\n  text-align: left;\n\n  span {\n    color: #dc3545;\n    margin-left: 2px;\n  }\n}\n\n.inputContainer {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.passwordInput {\n  width: 100%;\n  padding: 12px 45px 12px 14px;\n  border: 1px solid #dee2e6;\n  border-radius: 8px;\n  font-size: 14px;\n  outline: none;\n  transition: all 0.3s ease;\n  background-color: #ffffff;\n\n  &:focus {\n    border-color: #39979d;\n    box-shadow: 0 0 0 3px rgba(57, 151, 157, 0.1);\n  }\n\n  &::placeholder {\n    color: #adb5bd;\n  }\n\n  &:disabled {\n    background-color: #f8f9fa;\n    cursor: not-allowed;\n    opacity: 0.7;\n  }\n}\n\n.eyeButton {\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  transition: all 0.2s ease;\n  z-index: 1;\n\n  &:hover {\n    background-color: #f0f0f0;\n  }\n\n  &:focus {\n    outline: 2px solid #39979d;\n    outline-offset: 2px;\n  }\n\n  &:active {\n    background-color: #e0e0e0;\n  }\n\n  img {\n    width: 18px;\n    height: 18px;\n    opacity: 0.6;\n    transition: opacity 0.2s ease;\n  }\n\n  &:hover img {\n    opacity: 1;\n  }\n}\n\n.errorMessage,\n.text-red {\n  color: #dc3545;\n  font-size: 12px;\n  margin-top: 6px;\n  margin-bottom: 0;\n  text-align: left;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n\n  &::before {\n    content: '⚠';\n    font-size: 14px;\n  }\n}\n\n.modalFooter {\n  background-color: #ffffff;\n  border-top: 1px solid #e9ecef;\n  padding: 20px 25px;\n  gap: 10px;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.cancelButton {\n  padding: 10px 20px;\n  font-weight: 500;\n  border-radius: 6px;\n  transition: all 0.2s ease;\n  min-width: 100px;\n\n  &:hover:not(:disabled) {\n    background-color: #6c757d;\n    border-color: #6c757d;\n    transform: translateY(-1px);\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  }\n}\n\n.resetPasswordBtn {\n  padding: 10px 20px;\n  font-weight: 600;\n  border-radius: 6px;\n  background-color: #39979d;\n  border-color: #39979d;\n  color: white;\n  min-width: 150px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  transition: all 0.2s ease;\n\n  &:hover:not(:disabled) {\n    background-color: #2d7277;\n    border-color: #2d7277;\n    transform: translateY(-1px);\n    box-shadow: 0 4px 8px rgba(57, 151, 157, 0.3);\n  }\n\n  &:disabled {\n    opacity: 0.7;\n    cursor: not-allowed;\n  }\n\n  i {\n    font-size: 14px;\n  }\n}\n\n// Dark theme support\n.bodythemedark {\n  .modalBody {\n    background-color: #2d2d2d;\n    color: #e0e0e0;\n\n    .description {\n      color: #b0b0b0;\n    }\n  }\n\n  .passwordLabel {\n    color: #e0e0e0;\n  }\n\n  .passwordInput {\n    background-color: #3d3d3d;\n    border-color: #555;\n    color: #e0e0e0;\n\n    &:focus {\n      border-color: #39979d;\n      box-shadow: 0 0 0 3px rgba(57, 151, 157, 0.2);\n    }\n\n    &::placeholder {\n      color: #888;\n    }\n  }\n\n  .eyeButton {\n    &:hover {\n      background-color: #4d4d4d;\n    }\n\n    &:active {\n      background-color: #5d5d5d;\n    }\n  }\n\n  .modalFooter {\n    background-color: #2d2d2d;\n    border-color: #555;\n  }\n\n  .cancelButton {\n    background-color: #6c757d;\n    border-color: #6c757d;\n    color: white;\n\n    &:hover:not(:disabled) {\n      background-color: #5a6268;\n      border-color: #5a6268;\n    }\n  }\n}\n\n// Responsive design\n@media (max-width: 576px) {\n  .resetModal {\n    .modal-dialog {\n      margin: 10px;\n      max-width: calc(100% - 20px);\n    }\n  }\n\n  .modalHeader {\n    padding: 15px 20px;\n\n    .modal-title {\n      font-size: 16px;\n    }\n  }\n\n  .modalBody {\n    padding: 20px;\n  }\n\n  .modalFooter {\n    padding: 15px 20px;\n    flex-direction: column;\n\n    .cancelButton,\n    .resetPasswordBtn {\n      width: 100%;\n      margin: 2px 0;\n    }\n  }\n\n  .passwordField {\n    margin-bottom: 18px;\n  }\n}\n","@import url('https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap');\n\nbody {\n  font-family: \"Urbanist\", sans-serif !important;\n}\n\n/* \nscss\n */\n$font-regular: 400;\n$font-medium: 500;\n$font-semiBold: 600;\n$font-bold: 700;\n$font-extraBold: 800;\n$font-black: 900;\n\n$mainBg: #F5F6FA;\n$primary-color: #131F43;\n$icon-bgcolor: #F6F6F6;\n$text-graycolor: #727272;\n$cardIcon1-bg: #F3F4F8;\n$cardIcon1-darkbg: #30231a;\n$cardIcon1-darkbg-icon: #9d785f;\n$cardIcon2-bg: #FAF4FB;\n$cardIcon2-darkbg: #13252a;\n$cardIcon2-darkbg-icon: #3b606a;\n$cardIcon3-bg: #FAF7F3;\n$cardIcon3-darkbg: #2c1a27;\n$cardIcon3-darkbg-icon: #6c4863;\n$cardIcon4-bg: #F5F9FC;\n$cardIcon4-darkbg: #241d3e;\n$cardIcon4-darkbg-icon: #5f538b;\n$cardIcon2-color: #AC44BB;\n$cardIcon3-color: #D69A5F;\n$cardIcon4-color: #176CA5;\n$green-color: #38A169;\n$darkGreen-color: #207a4a;\n$placeholder-color: #666666;\n$profile-dark-text: #181818;\n$heading : #0B0D0F;\n$light-gray : #999999;\n$menu_icon : #CBCBCB;\n$red-color : #F94747;\n$dark-active-blue : #3b82f6;\n$dark-light-blue : #92afd3;\n$addBtn-dark-blue : #3b82f6;\n$addBtn-dark-blue-hover : #2563eb;\n$backBtn-dark : #3b82f633;\n\n\n\n$darkTheme_blue : #132337;\n$darkTheme_darkBlue : #0f1824;\n$darkTheme_selectBlue : #1c2e45;\n$darkTheme_updateBtn : #0a2574;\n\n/* \nBody Theme Color\n */\n$lightthemecolor: #f3f6f9;\n$darkthemecolor: #151521;\n\n$white-color: #fff;\n$black-color: #1d1d1d;\n$fullBlack-color: #1d1d1d;\n$lightthemetext: #60677e;\n\n/* \nDark Theme Colors\n*/\n$primarydark-color: #132337;\n\n/* \nButton Theme\n*/\n$primary-btncolor: #131F43;\n$secondary-btncolor: rgba(37, 105, 109, 0.864);\n\n$tableheadlightbg: #e9eaf0;\n\n\n/* \nMax Dashboard scss\n*/\n$dashboardwidth: calc(100% - 320px);\n$dashboardposition: absolute;\n$dashboardleft: 310px;\n$dashboardpadding: 30px;\n\n/* \nMin Dashboard scss\n*/\n$dashwidth: calc(100% - 50px);\n$dashleft: 50px;\n\n/* \nMax Dashboard scss\n*/\n\n.dashboard {\n  width: $dashboardwidth;\n  position: relative;\n  left: $dashboardleft;\n  padding: $dashboardpadding;\n  border-radius: 8px;\n  min-height: auto !important;\n  background-color: $mainBg;\n  height: calc(100vh - 160px);\n  overflow-y: auto;\n}\n.dashboardContain { \n  width: calc(100% - 320px);\n  background-Color:$mainBg;\n  border-radius: 8px;\n}\n.bodythemedark .dashboardContain,\n.bodythemedark .dashboard, \n.bodythemedark .cont2 { \n  background-Color: $darkTheme_darkBlue;\n}\n.top_header .top_header_inner {\n  background-color: transparent;\n  height: auto;\n  overflow-y: unset;\n}\n\n/* \nMin Dashboard scss\n*/\n\n.cont2 {\n  width: $dashwidth;\n  left: $dashleft;\n  position: relative;\n  padding: $dashboardpadding;\n  border-radius: 8px;\n  background: $mainBg;\n  height: calc(100vh - 160px);\n  min-height: auto !important;\n  overflow-y: auto;\n  /* \nbackground-Color: $dashboardbackgroundColor;\n  padding-bottom: 8%;\n*/\n}\n\n\n\n\n.footer {\n  height: 70px;\n}\n\nbody {\n  background-color: $white-color;\n}\n\n/* \nTHEME CHANGE\n*/\n.bodythemelight {\n  background-color: $white-color;\n  padding-top: 90px;\n}\n.bodythemedark {\n  background-color: $darkTheme_blue;\n  padding-top: 90px;\n}\n\n/* \nHeader Navbar Theme\n*/\n.headerthemelight {\n  background-color: $white-color;\n}\n\n.headerthemedark {\n  background-color: $darkTheme_blue;\n}\n.top_header {\n  min-height: 90px;\n  display: flex;\n  align-items: center;\n  position: fixed;\n  width: 100%;\n  z-index: 1; \n  top: 0;\n}\n\n/* \nLEFT MENU THEME CHANGE\n*/\n.menuthemelight {\n  background-color: $white-color;\n}\n.menuthemedark {\n  background-color: $darkTheme_blue;\n}\n\n/* \nLEFT MENU LINKS THEME CHANGE\n*/\n.menulinklight span {\n  color: $placeholder-color !important;\n}\n\n.menulinklight a {\n  color: $menu_icon !important;\n}\n\n.menulinklight:hover span, .menulinklight:hover a { \n  color: $white-color !important;\n}\n\n.menulinkdarkSelected {\n  background-color: $darkTheme_selectBlue;\n  color: $dark-active-blue;\n}\n.menuthemelight .menulinklightSelected {\n  /*background-color: $lightthemecolor;*/\n  color: $white-color !important;\n  background-color: $primary-color;\n}\n\n.menulinkdark {\n  color: $dark-light-blue !important;\n}\n\n.menulinklight:hover {\n  color: $white-color !important;\n  background-color: $primary-color;\n}\n\n.menulinklight .sub_arrow svg path{\n  stroke: $menu_icon !important;\n}\n\n.menulinklight:hover .sub_arrow svg path{\n  stroke: $white-color !important;\n}\n\n.menulinkdark .sub_arrow svg path{\n  stroke: $dark-light-blue !important;\n}\n\n.menulinkdark:hover .sub_arrow svg path{\n  stroke: $white-color !important;\n}\n\n.menulinkdark:hover {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n/* \nBODY HEADERS\n*/\n.headinglight {\n  color: $lightthemetext;\n}\n\n.headingdark {\n  color: $lightthemetext;\n}\n\n/* \nSEARCH BOX THEME COLOR\n*/\n.searchboxlight {\n  background-color: $white-color;\n  border: none;\n}\n\n.searchboxdark {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n  border: none;\n}\n.searchboxdark::placeholder {\n  color: $lightthemetext;\n}\n\n/* \nCUSTOM TABLE THEME COLOR\n*/\n.tableheadlight {\n  background-color: $primary-color;\n  border-radius: 5px 5px 0px 0px;\n}\n.tableheadlight th {\n  color: $white-color;\n}\nthead .tableheadlight th:first-child,\nthead .tableheaddark th:first-child {\n  border-radius: 5px 0 0 0px;\n} \nthead .tableheadlight th:last-child,\nthead .tableheaddark th:last-child  {\n  border-radius: 0 5px 0px 0;\n}\nth:first-child {\n  border-radius: 0px;\n} \ntd:last-child {\n  border-radius: 0px;\n}\ntable.table.table-borderless{\n  border-collapse: separate !important;\n  border-spacing: 0 0px !important;\n}\n\n.tableheaddark {\n  background-color: $primarydark-color;\n  color: $white-color;\n}\n.table-borderless tr:nth-child(even) {\n  background-color: #F9FAFB;\n}\n.table-borderless .left-section {\n  padding-top: 10px;\n}\n.tablebodylight td, \n.tablebodydark td {\n  padding: 0.5rem 1rem !important;\n  line-height: 45px;\n}\n.tablebodylight {\n  background-color: $white-color;\n\n  &:hover {\n    background-color: #ddecf9;\n    cursor: auto;\n  }\n}\n.tablebodydark {\n /* background-color: $primarydark-color; */\n  color: $lightthemetext;\n\n  &:hover {\n    background-color: rgba(33, 150, 243, 0.1);\n    cursor: auto;\n  }\n}\n\n/* \nPAGINATION THEME COLOR\n*/\n.paginationlight {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n.paginationdark {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n\n/* \nSETTING FORM THEME COLOR\n*/\n.formthemelight {\n  background-color: $white-color;\n  color: $black-color !important;\n  box-shadow: 0px 10px 35px 0px rgb(56 71 109 / 8%);\n}\n.formthemedark {\n  background-color: $primarydark-color;\n  color: $lightthemetext !important;\n  font-size: 14px;\n\n  ::placeholder {\n    color: $lightthemetext;\n  }\n}\n\n\n/* \nVIEW FORM DETAILS BOX THEME COLOR\n*/\n.viewformlight {\n  background-color: $lightthemecolor;\n}\n\n.permissionboxlight {\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n}\n.permissionboxdark {\n  background-color: $darkTheme_darkBlue;\n  border: solid 1px #242434;\n}\n\n.errormsgclr {\n  color: red;\n  font-size: 14px;\n  margin-top: 5px;\n}\n\n/* \nGraph theme\n*/\n.graphclrlight {\n  background-color: $white-color;\n}\n\n.graphclrdark {\n  background-color: $primarydark-color;\n}\n\n\n/* \nCounter theme\n*/\n#card1bglight {\n  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card1bgdark {\n  background: #392f28;\n}\n\n#card2bglight {\n  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card2bgdark {\n  background: #1c3238;\n}\n\n#card3bglight {\n  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card3bgdark {\n  background: #3a2434;\n}\n\n#card4bglight {\n  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card4bgdark {\n  background: #2f264f;\n}\n\n#card1bgdark a, #card1bgdark p,\n#card2bgdark a , #card2bgdark p,\n#card3bgdark a, #card3bgdark p,\n#card4bgdark a, #card4bgdark p {\n  color: $white-color;\n}\n\n/* \nAction button theme\n*/\n.actionbtnlight {\n  color: #46475bde;\n}\n.actionbtnlight:hover{\n  cursor: pointer;\n}\n.actionbtndark {\n  color: $lightthemetext;\n}\n\n\n/* \nprofile dropdowntheme\n*/\n.profiledropdownlight {\n  background-color: #fff;\n}\n\n.profiledropdowndark {\n  background-color: #151521;\n}\n\n.settingsection #addform.formthemedark .savebtn {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n#addform.formthemedark .savebtn {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.profile_conatiner {\n  border-radius: 5px !important; \n}\n\n.bodythemedark .ag-theme-alpine .ag-row {\n  background: #000 !important;\n}\n\n.bodythemedark .formbtn {\n  background-color: $addBtn-dark-blue;\n}\n\n.bodythemedark .formbtn:hover {\n  background-color: $addBtn-dark-blue-hover;\n}\n\n.bodythemedark .resetbtn {\n  color: $white-color;\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n}\n\n.bodythemedark .resetbtn:hover {\n  background-color: $addBtn-dark-blue;\n}\n\n\n.headingdark span {\n  background-color: $darkTheme_blue;\n}\n\n.resetbtn {\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border-radius: 5px;\n  background-color: transparent;\n  border: solid 1px $primary-color;\n  color:  $primary-color;\n  min-width: 113px;\n}\n.resetbtn:hover, \n.resetbtn:active, \n.resetbtn:focus {\n  background-color: $primary-color;\n  color: $white-color;\n}\n\n.addBtn {\n  min-width: 140px;\n  height: 44px;\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n}\n\n.addbtnlight {\n  background-color: $green-color;\n}\n.addbtndark {\n  background-color: $addBtn-dark-blue;\n}\n.addbtndark:hover {\n  background-color: $addBtn-dark-blue-hover;\n}\n\n.formthemedark label {\n  color: $dark-light-blue;\n}\n\n\n.addBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: 2px;\n}\n\n.addBtn:hover {\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n}\n\n.cust_addBtn.addBtn svg {\n  top: 2px;\n}\n\n.deleteBtn {\n  min-width: 130px;\n  height: 50px;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn {\n  min-width: 130px;\n  height: 50px;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn:active, .deleteBtn:focus {\n  background-color: $red-color !important;\n  color: $white-color !important; \n  box-shadow: none !important;\n}\n\n.deleteBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: -2px;\n}\n\n.deleteBtn:hover, \n.deleteBtn:active, \n.deleteBtn:focus {\n  background-color: $red-color;\n  color: $white-color;\n  border: none;\n}\n\n.confirmBtn {\n  background-color: $primary-color;\n}\n\n.confirmBtn:hover, \n.confirmBtn:active, \n.confirmBtn:focus {\n  background-color: $primary-color;\n}\n\n.confirmBtn svg {\n  top: 0;\n}\n\n\n\n.delPopContainer .modal-body {\n  padding: 25px;\n  text-align: center;\n}\n\n.delPopContainer .delet_icon {\n  margin-bottom: 11px;\n}\n\n.delPopContainer p {\n  color: #131f43;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.arrowback svg{\n  fill: #000; \n}\n\n.bodythemedark .arrowback {\n  background-color: $backBtn-dark; \n  color: $dark-active-blue;\n}\n\n.bodythemedark .arrowback svg {\n  fill: $dark-active-blue;\n}\n\n.bodythemedark .drpdwn_btn {\n  background-color: $darkTheme_blue;\n}\n\n.bodythemedark .empname {\n  color: $dark-light-blue !important;\n}\n\n.bodythemedark .navitemli a {\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.bodythemedark .tabnavli a.settingsgeneral, \n.bodythemedark .tabnavli a.settingslinks:hover {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n.bodythemedark .tabnavli a.settingslinks {\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain ul li a,\n.headerthemedark .dropdown_menu_contain .dropdown_item, \n.headerthemedark .dropdown_menu_contain .dropdown_item h5 {\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain ul li a:hover,\n.headerthemedark .dropdown_menu_contain .dropdown_item:hover {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n}\n\n.dropdown_item:active {\n  background-color: $mainBg;\n}\n\n.profile_arrrow_dwn {\n  stroke: $darkTheme_blue;\n}\n\n.headerthemedark .profile_arrrow_dwn {\n  stroke: $white-color;\n}\n\n.dateinputbox1 input, \n.dateinputbox1 span {\n  color: $white-color !important;\n}\n\n/* LOGOUT MODAL */\n.modalStyleLight {\n\n}\n\n.modalStyleDark {\n  \n}\n\n\n@media only screen and (max-width: 1200px) {\n  .tableheadlight th {\n    min-width: 100px;\n  }\n}\n@media only screen and (max-width: 1024px) { \n  .dashboard {\n    width: calc(100% - 50px) !important;\n    left: 50px !important;\n    padding: 10px 10px !important;\n  }\n  .cont2 {\n    height: calc(100vh - 160px);\n    overflow-y: auto;\n  }\n}\n@media only screen and (max-width: 998px) { \n /* #dashboardcont2{\n    height: auto !important;\n  }*/\n}\n@media only screen and (max-width: 767px) { \n  .sectionright{\n    float: unset !important;\n  }\n  .dashboard {\n    padding: 10px 10px !important;\n  }\n}\n@media only screen and (max-width: 600px) {\n  .cont2 {\n    width: $dashwidth !important;\n    left: $dashleft !important;\n    position: relative !important;\n    padding: 10px !important;\n  }\n  .bodythemelight, .bodythemedark {\n    padding-top: 110px;\n  }\n}\n\n@media (min-width: 576px) {\n  .exer_modal_contain .modal-dialog {\n      max-width: 1055px;\n  }\n  .delPopContainer .modal-dialog {\n      max-width: 350px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboard": `ResetPasswordModal_dashboard__mlX8+`,
	"dashboardContain": `ResetPasswordModal_dashboardContain__fk-Et`,
	"bodythemedark": `ResetPasswordModal_bodythemedark__vdEMg`,
	"cont2": `ResetPasswordModal_cont2__JEBxl`,
	"top_header": `ResetPasswordModal_top_header__KeJgC`,
	"top_header_inner": `ResetPasswordModal_top_header_inner__wWM2L`,
	"footer": `ResetPasswordModal_footer__iZk3Q`,
	"bodythemelight": `ResetPasswordModal_bodythemelight__zm2-h`,
	"headerthemelight": `ResetPasswordModal_headerthemelight__RUT-V`,
	"headerthemedark": `ResetPasswordModal_headerthemedark__G6fuS`,
	"menuthemelight": `ResetPasswordModal_menuthemelight__KsURa`,
	"menuthemedark": `ResetPasswordModal_menuthemedark__OpGtX`,
	"menulinklight": `ResetPasswordModal_menulinklight__U0EpR`,
	"menulinkdarkSelected": `ResetPasswordModal_menulinkdarkSelected__XuEiS`,
	"menulinklightSelected": `ResetPasswordModal_menulinklightSelected__sNOsp`,
	"menulinkdark": `ResetPasswordModal_menulinkdark__alK5Z`,
	"sub_arrow": `ResetPasswordModal_sub_arrow__gEcvY`,
	"headinglight": `ResetPasswordModal_headinglight__WDuH5`,
	"headingdark": `ResetPasswordModal_headingdark__HwQ6q`,
	"searchboxlight": `ResetPasswordModal_searchboxlight__zcpWw`,
	"searchboxdark": `ResetPasswordModal_searchboxdark__Oa6H0`,
	"tableheadlight": `ResetPasswordModal_tableheadlight__eCjhU`,
	"tableheaddark": `ResetPasswordModal_tableheaddark__e6a4E`,
	"table": `ResetPasswordModal_table__g8+-G`,
	"table-borderless": `ResetPasswordModal_table-borderless__Mce5w`,
	"left-section": `ResetPasswordModal_left-section__ZfA8D`,
	"tablebodylight": `ResetPasswordModal_tablebodylight__i5KAv`,
	"tablebodydark": `ResetPasswordModal_tablebodydark__dyZaU`,
	"paginationlight": `ResetPasswordModal_paginationlight__Ce+s6`,
	"paginationdark": `ResetPasswordModal_paginationdark__PV9Cv`,
	"formthemelight": `ResetPasswordModal_formthemelight__jVE1H`,
	"formthemedark": `ResetPasswordModal_formthemedark__77r9J`,
	"viewformlight": `ResetPasswordModal_viewformlight__kkgA5`,
	"permissionboxlight": `ResetPasswordModal_permissionboxlight__WeqyB`,
	"permissionboxdark": `ResetPasswordModal_permissionboxdark__3tPUy`,
	"errormsgclr": `ResetPasswordModal_errormsgclr__CPNMU`,
	"graphclrlight": `ResetPasswordModal_graphclrlight__a+biF`,
	"graphclrdark": `ResetPasswordModal_graphclrdark__zhiQF`,
	"card1bglight": `ResetPasswordModal_card1bglight__xX1Nb`,
	"card1bgdark": `ResetPasswordModal_card1bgdark__on2aN`,
	"card2bglight": `ResetPasswordModal_card2bglight__UhOhK`,
	"card2bgdark": `ResetPasswordModal_card2bgdark__CTvTF`,
	"card3bglight": `ResetPasswordModal_card3bglight__L5QQz`,
	"card3bgdark": `ResetPasswordModal_card3bgdark__8Fusg`,
	"card4bglight": `ResetPasswordModal_card4bglight__fj1DU`,
	"card4bgdark": `ResetPasswordModal_card4bgdark__rH+64`,
	"actionbtnlight": `ResetPasswordModal_actionbtnlight__AZF1o`,
	"actionbtndark": `ResetPasswordModal_actionbtndark__4FOL8`,
	"profiledropdownlight": `ResetPasswordModal_profiledropdownlight__2hE-5`,
	"profiledropdowndark": `ResetPasswordModal_profiledropdowndark__3YFIN`,
	"settingsection": `ResetPasswordModal_settingsection__FGU+k`,
	"addform": `ResetPasswordModal_addform__bZzkV`,
	"savebtn": `ResetPasswordModal_savebtn__eP9aA`,
	"profile_conatiner": `ResetPasswordModal_profile_conatiner__VNaHQ`,
	"ag-theme-alpine": `ResetPasswordModal_ag-theme-alpine__jJfn4`,
	"ag-row": `ResetPasswordModal_ag-row__a-JvN`,
	"formbtn": `ResetPasswordModal_formbtn__RR+nP`,
	"resetbtn": `ResetPasswordModal_resetbtn__ADW5+`,
	"addBtn": `ResetPasswordModal_addBtn__6GD2V`,
	"addbtnlight": `ResetPasswordModal_addbtnlight__6Po0c`,
	"addbtndark": `ResetPasswordModal_addbtndark__OMnlb`,
	"cust_addBtn": `ResetPasswordModal_cust_addBtn__ontZk`,
	"deleteBtn": `ResetPasswordModal_deleteBtn__cWGEW`,
	"confirmBtn": `ResetPasswordModal_confirmBtn__qYUxn`,
	"delPopContainer": `ResetPasswordModal_delPopContainer__Amlsf`,
	"modal-body": `ResetPasswordModal_modal-body__a1NE3`,
	"delet_icon": `ResetPasswordModal_delet_icon__PK8c6`,
	"arrowback": `ResetPasswordModal_arrowback__gXsfb`,
	"drpdwn_btn": `ResetPasswordModal_drpdwn_btn__bWAdZ`,
	"empname": `ResetPasswordModal_empname__umGWH`,
	"navitemli": `ResetPasswordModal_navitemli__tGeEV`,
	"tabnavli": `ResetPasswordModal_tabnavli__Kckcy`,
	"settingsgeneral": `ResetPasswordModal_settingsgeneral__HEmo+`,
	"settingslinks": `ResetPasswordModal_settingslinks__Lg1nQ`,
	"dropdown_menu_contain": `ResetPasswordModal_dropdown_menu_contain__vpVJb`,
	"dropdown_item": `ResetPasswordModal_dropdown_item__-3JF2`,
	"profile_arrrow_dwn": `ResetPasswordModal_profile_arrrow_dwn__ZHLBb`,
	"dateinputbox1": `ResetPasswordModal_dateinputbox1__FkvKw`,
	"sectionright": `ResetPasswordModal_sectionright__3Nem+`,
	"exer_modal_contain": `ResetPasswordModal_exer_modal_contain__U4qAc`,
	"modal-dialog": `ResetPasswordModal_modal-dialog__BEH+G`,
	"resetModal": `ResetPasswordModal_resetModal__XZYrU`,
	"modalHeader": `ResetPasswordModal_modalHeader__EBC9y`,
	"modal-title": `ResetPasswordModal_modal-title__CwTS5`,
	"btn-close": `ResetPasswordModal_btn-close__SmJcb`,
	"modalBody": `ResetPasswordModal_modalBody__lCzsk`,
	"description": `ResetPasswordModal_description__8QcFL`,
	"passwordField": `ResetPasswordModal_passwordField__Nns63`,
	"passwordLabel": `ResetPasswordModal_passwordLabel__0VcsR`,
	"inputContainer": `ResetPasswordModal_inputContainer__JV9ee`,
	"passwordInput": `ResetPasswordModal_passwordInput__g1ufS`,
	"eyeButton": `ResetPasswordModal_eyeButton__2SpcC`,
	"errorMessage": `ResetPasswordModal_errorMessage__QnCsw`,
	"text-red": `ResetPasswordModal_text-red__vm3VJ`,
	"modalFooter": `ResetPasswordModal_modalFooter__wdsLu`,
	"cancelButton": `ResetPasswordModal_cancelButton__dhzTl`,
	"resetPasswordBtn": `ResetPasswordModal_resetPasswordBtn__ihrqO`
};
export default ___CSS_LOADER_EXPORT___;
